function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var POST_ADVERTISMENT_REQUEST = "POST_ADVERTISMENT_REQUEST";
export var POST_ADVERTISMENT_SUCCESS = "POST_ADVERTISMENT_SUCCESS";
export var POST_ADVERTISMENT_FAILURE = "POST_ADVERTISMENT_FAILURE";
export var RESET_POST_ADVERTISMENT = "RESET_POST_ADVERTISMENT";
export var postAdvertisement = function postAdvertisement(advertisement) {
  return _defineProperty({}, CALL_API, {
    types: [POST_ADVERTISMENT_REQUEST, POST_ADVERTISMENT_SUCCESS, POST_ADVERTISMENT_FAILURE],
    endpoint: "advertisements",
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(advertisement),
      credentials: "same-origin"
    }
  });
};
export var resetPostAdvertisement = function resetPostAdvertisement() {
  return {
    type: RESET_POST_ADVERTISMENT
  };
};
export var POST_ADVERTISMENTMEDIA_REQUEST = "POST_ADVERTISMENTMEDIA_REQUEST";
export var POST_ADVERTISMENTMEDIA_SUCCESS = "POST_ADVERTISMENTMEDIA_SUCCESS";
export var POST_ADVERTISMENTMEDIA_FAILURE = "POST_ADVERTISMENTMEDIA_FAILURE";
export var RESET_POST_ADVERTISMENTMEDIA = "RESET_POST_ADVERTISMENTMEDIA";
export var postAdvertisementMedia = function postAdvertisementMedia(advertisement, media) {
  return _defineProperty({
    advertisement: advertisement,
    media: media
  }, CALL_API, {
    types: [POST_ADVERTISMENTMEDIA_REQUEST, POST_ADVERTISMENTMEDIA_SUCCESS, POST_ADVERTISMENTMEDIA_FAILURE],
    endpoint: "advertisements/".concat(advertisement.id, "/media"),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(media),
      credentials: "same-origin"
    }
  });
};